import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["date"];

  connect() {
    const today = new Date();
    const date = new Date(this.dateTarget.innerText * 1000);
    // if (today.toDateString() === date.toDateString()) {
      this.dateTarget.innerText = date.toLocaleString();
    // }
  }
}